import {
	Sidebar,
	Menu,
	MenuItem,
	SubMenu
} from "react-pro-sidebar";
import employerMenuData from "../../../data/employerMenuData";
import SidebarFooter from "./SidebarFooter";
import SidebarHeader from "./SidebarHeader";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isActiveLink } from "../../../utils/linkActiveChecker";
import { menuToggle } from "../../../features/toggle/toggleSlice";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setData } from "../../../redux/menuSlice";


// TEMP: Hard-coded Legacy Life Entry menu.
// Remove this block after the menu is configured through the normal permission/menu API.
const LEGACY_LIFE_ENTRY_MENU = {
	id: "hardcoded-legacy-life-entry",
	name: "legacyLifeEntry.title",
	icon: "la-file-contract",
	routePath: "/admin/legacyLifeEntry/list",
	children: [
		{
			id: "hardcoded-legacy-life-entry-create",
			name: "legacyLifeEntry.createContract",
			routePath: "/admin/legacyLifeEntry/save",
		},
		{
			id: "hardcoded-legacy-life-entry-bill",
			name: "legacyLifeEntry.billEntryTitle",
			routePath: "/admin/legacyLifeEntry/bill",
		},
		{
			id: "hardcoded-legacy-life-entry-list",
			name: "legacyLifeEntry.listTitle",
			routePath: "/admin/legacyLifeEntry/list",
		},
		{
			id: "hardcoded-legacy-life-entry-approval",
			name: "legacyLifeEntry.approvalListTitle",
			routePath: "/admin/legacyLifeEntry/approval",
		},
	],
};

const withLegacyLifeEntryMenu = (menu = []) => {
	const hasLegacyMenu = menu.some(
		(item) => item.id === LEGACY_LIFE_ENTRY_MENU.id || item.routePath?.startsWith("/admin/legacyLifeEntry")
	);

	return hasLegacyMenu ? menu : [...menu, LEGACY_LIFE_ENTRY_MENU];
};

const Index = ({ offcanvasId = "offcanvasMenu" }) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { menu } = useSelector((state) => state.toggle);
	const { t } = useTranslation();
	const userInfo = useSelector((state) => state.dataLogin);
	const [dataMenu, setDataMenu] = useState([]);
	const [openMenu, setOpenMenu] = useState(null);

	const dispatch = useDispatch();

	useEffect(() => {

		const adminMenu = localStorage.getItem('adminMenu');
		const menu = withLegacyLifeEntryMenu(adminMenu ? JSON.parse(adminMenu) : []);
		setDataMenu(menu);

		{
			const parentMenu = menu.find((item) =>
				item.children?.some((child) => isActiveLink(child.routePath, pathname))
			);
			if (parentMenu) {
				setOpenMenu(parentMenu.id);
			}
			const currentItem =
				menu.flatMap(parent =>
					parent.children?.length ? parent.children : [parent]
				).find((item) => isActiveLink(item.routePath, pathname));

			if (currentItem && currentItem.permissions) {
				dispatch(setData(currentItem.permissions));
			}
		}
		// setDataMenu(employerMenuData);

		// const parentMenu = employerMenuData.find((item) =>
		// 	item.children?.some((child) => isActiveLink(child.routePath, pathname))
		// );
		// if (parentMenu) {
		// 	setOpenMenu(parentMenu.id);
		// }
	}, [pathname]);

	const menuToggleHandler = () => {
		dispatch(menuToggle());
	};

	const handleLinkClick = (e, item) => {

		if (item.routePath === "/logout") {
			e.preventDefault();
			Swal.fire({
				title: t("areYouSure"),
				text: t("confirmLogout"),
				icon: "question",
				reverseButtons: true,
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: t("confirm"),
				cancelButtonText: t("cancel"),
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.href = "/logout";
				}
			});
		} else {
			navigate(item.routePath)
		}
	};

	const toggleSubMenu = (e, id) => {
		e.preventDefault();
		setOpenMenu(openMenu === id ? null : id);
	};
	return (
		<div
			className="offcanvas offcanvas-start mobile_menu-contnet"
			tabIndex="-1"
			id={offcanvasId}
			data-bs-scroll="true"
		>
			<SidebarHeader />

			<Sidebar>
				<Menu>

					{dataMenu?.map((item) => {
						const hasSubmenu = item.children && item.children.length > 0;
						const isChildActive = hasSubmenu && item.children.some((child) => isActiveLink(child.routePath, pathname));
						const isSelfActive = isActiveLink(item.routePath, pathname);
						const isOpen = openMenu === item.id;

						// ให้ active แค่ถ้าไม่มี submenu หรือมี routePath ตรงจริง
						const shouldSetActive = !hasSubmenu && isSelfActive;

						return (
							!hasSubmenu ?
								<MenuItem

									onClick={(e) => {
										handleLinkClick(e, item);
										dispatch(setData(item.permissions));
									}}
									className={
										shouldSetActive
											? "menu-active-link"
											: ""
									}
									key={item.id}
								>
									{t(item.name)}</MenuItem> :

								<SubMenu
									className={
										isChildActive
											? "menu-active"
											: ""
									}
									label={t(item.name)}
									key={item.id}
									open={isOpen}
									onClick={(e) => toggleSubMenu(e, item.id)}
								>
									{hasSubmenu && item.children.map((child, i) => {
										const isChildSelected = isActiveLink(child.routePath, pathname);
										return <MenuItem

											onClick={(e) => {
												handleLinkClick(e, child);
												dispatch(setData(item.permissions));
											}}
											className={
												isChildSelected
													? "menu-active-link"
													: ""
											}
											key={i}
										// routerLink={<Link to={menuItem.routePath} />}
										>
											{t(child.name)}
										</MenuItem>
									})}
								</SubMenu>
							// <li key={item.id} className={`${shouldSetActive ? "active" : ""}`}>
							// 	<div
							// 		className={`menu-link d-flex justify-content-between align-items-center rounded ${shouldSetActive ? "active" : ""}`}
							// 		onClick={(e) => {
							// 			if (hasSubmenu) {
							// 				toggleSubMenu(e, item.id);
							// 			} else {
							// 				menuToggleHandler();
							// 			}
							// 		}}
							// 		style={{ cursor: "pointer" }}
							// 	>
							// 		<Link
							// 			to={item.routePath}
							// 			onClick={(e) => handleLinkClick(e, item)}
							// 			className="d-flex align-items-center w-100 text-decoration-none text-dark"
							// 		>
							// 			<i className={`la ${item.icon}`}></i>
							// 			<span>{t(item.name)}</span>
							// 		</Link>
							// 		{hasSubmenu && (
							// 			<i
							// 				className={`la la-angle-down transition isSubmenu ${isOpen ? "rotate-180" : ""}`}
							// 			></i>
							// 		)}
							// 	</div>

							// 	{hasSubmenu && (
							// 		<ul className={`submenu mt-1 transition ${isOpen ? "d-block" : "d-none"}`}>
							// 			{item.children.map((child) => {
							// 				const isChildSelected = isActiveLink(child.routePath, pathname);
							// 				return (
							// 					<li key={child.id}>
							// 						<Link
							// 							to={child.routePath}
							// 							onClick={(e) => {
							// 								handleLinkClick(e, child);
							// 								dispatch(setData(item.permissions));
							// 							}}
							// 							className={`d-block rounded text-decoration-none ${isChildSelected ? "submenuActive text-dark" : "text-dark"}`}
							// 						>
							// 							<i className={`${child.icon} ${isChildSelected ? "" : "text-dark"}`}></i>
							// 							<span>{t(child.name)}</span>
							// 						</Link>
							// 					</li>
							// 				);
							// 			})}
							// 		</ul>
							// 	)}
							// </li>

						)



					})}
				</Menu>
			</Sidebar>
		</div >
	);
};

export default Index;
